angular.module("kilo.config")

.constant("version", "1.33.7")

.constant("appId", "M2JlYzM0OGQtMTM0Zi00ZDdmLTg0NDctNTE3ZTJkYmY5Njg3")

.constant("urls", {
	"auth": "https://account.90tech.fr",
	"uploader": "https://uploader.90tech.fr",
	"downloader": "https://downloader.90tech.fr",
	"api": "https://api.90tech.fr",
	"backend": "https://apikilo.90tech.fr",
	"socketnotif": "https://socketn.90tech.fr/pusher/auth",
	"extranet": "https://extranet-sufa.90tech.fr",
	"soli": "https://app.soli.tech",
	"backendChorus": "https://apichorus.90tech.fr",
	"backendPennylane": "https://apipennylane.90tech.fr",
	"backendEmail": "https://backend-email-preprod.90tech.fr"
})

.constant("accessibleApps", {
	"SOLITECH": "OGExMmMxN2MtYmI5Ny00ZjFmLWI3ZTItOTJmYTMyYTA5ZDA1",
	"CHORUS": "NTk4NTc2YjctN2I3MC00Yzk2LTg0MGEtM2NmNmE5MTg2NzJl",
	"LOKATECH": "MGFhYjg2NjUtOGJlMS00NDM1LThmOTYtZjg0NjUwMmIwMDAy",
	"FLUIDTECH": "NjY5OWJlYWEtNzE5Ni00YjQ1LTkyODYtMTNlODllOTA4MWQw",
	"ALIATECH": "Mzg0ZjdlM2UtMzE0Yy00YWRiLThhNzktZWQ5OGRlMDU5Mjcy"
})

.constant("quoteInvoiceDueDateCompany", [
	{
		"value": "0386cb95-6233-4a4b-af53-ff5776322d80",
		"name": "ejm"
	},
	{
		"value": "3c142e44-4a46-4ffa-a5aa-9212986ca2ce",
		"name": "ldn"
	}
])

.constant("pusherAPI", "b2f9684a5647b7a330f6")

.constant("apps", {
	"SOLITECH": "OGExMmMxN2MtYmI5Ny00ZjFmLWI3ZTItOTJmYTMyYTA5ZDA1",
	"CHORUS": "NTk4NTc2YjctN2I3MC00Yzk2LTg0MGEtM2NmNmE5MTg2NzJl",
	"LOKATECH": "MGFhYjg2NjUtOGJlMS00NDM1LThmOTYtZjg0NjUwMmIwMDAy",
	"FLUIDTECH": "NjY5OWJlYWEtNzE5Ni00YjQ1LTkyODYtMTNlODllOTA4MWQw",
	"ALIATECH": "Mzg0ZjdlM2UtMzE0Yy00YWRiLThhNzktZWQ5OGRlMDU5Mjcy"
})

.constant("environment", "local")

.constant("sentry", "https://7274d821c09b4275a3740550bba97d75@sentry.90tech.fr/8")

.constant("commit", "5574daa9")

.constant("branch", "master")

;